<template>
<!-- HISTORY: no-version   
- V260305.1: Moved the logic from BtChartForLS.vue to this component to support calculated columns and additional features.
-->
   <div>
      <v-row dense
         v-for="(item) in kpiData"
         :key="item.key"
         class="body-1 font-weight-bold"
      >
         <!-- <v-col cols="12"><span class="grey--text text-darken-1">{{ item.key }}: </span>{{ formatNumber(item.value) }}</v-col> -->
         <v-col cols="12"><span class="grey--text text-darken-1">{{ item.key }}: </span>{{ formatValue(item) }}</v-col>
      </v-row>
   </div>
</template>

<script>
import { isEmpty } from '../mixins/bt-mixin.js';

const NAME = 'BtKpiForLS'
const MSG = `-----${NAME} V260305.1 says => `;

function _findVariables(expression) {
   const startMark = "{{";
   const endMark = "}}";
   const regEx = /{{[^{]+}}/g;
   const matches = expression.match(regEx) || [];
   const vars = [];

   matches.forEach(match => {
      const key = match.replace(startMark, '').replace(endMark, '');
      if (key) vars.push(key);
   });

   return vars;
}

export default {
   name: NAME,

   props: {
      calculatedColumns: {
         //[{name:'',expression:'1 or more {{}}',fix:'none::|pre::text|post::text',position:'s::|e::|b::name|a::name'}
         type: Array,
         default: () => []
      },
      debug: {
         type: Boolean,
         default: false
      },
      loading: {
         type: Boolean,
         default: false
      },
      originalData: {
         type: [Object, Array],
         default: () => {}
      },
      visibleMetrics: {
         type: Array,
         default: () => []
      }
   },

   data() {
      return {
         kpiData: []
      };
   },

   computed: { },

   watch: {
      originalData: {
         immediate: true,
         deep: true,
         handler() {
            this.init();
         }
      },

      calculatedColumns: {
         immediate: true,
         deep: true,
         handler() {
            this.init();
         }
      }
   },

   methods: {
      // formatNumber,
      _alert(msg) {
         if (this.debug) {
            alert(msg);
         }
      },

      log(msg, isError) {
         if (isError)
            console.error(`${MSG}${msg}`);
         else if (this.debug) {
            console.log(`${MSG}${msg}`);
            alert(`${MSG}${msg}`);
         }
      },

      formatValue(item) {
         let result = new Intl.NumberFormat().format(item.value);
         const calCol = this.calculatedColumns?.find(cc => cc.name === item.key);
         if (calCol) {
            const fixParts = calCol.fix.split('::');
            if (fixParts[1] === '%') {
               result = new Intl.NumberFormat('en-US',
                  {
                     minimumFractionDigits: 2,
                     maximumFractionDigits: 2
                  }
               ).format(item.value);
            }
            
            if (fixParts[0] === 'pre')
               result = fixParts[1] + result;
            else if (fixParts[0] === 'post')
               result += fixParts[1];
         }
         return result;
      },

      init() {
         this.kpiData = [];
         if (this.isEditing || isEmpty(this.originalData)) return;

         const data = Object.entries(this.originalData).map(([key, value]) => {
            return {
               key,
               value,
               isVisible: this.visibleMetrics?.includes(key)
            };
         });

         let sSeq = 0;
         this.calculatedColumns?.forEach(calCol => {
            const calColVars = _findVariables(calCol.expression);
            let resolvedExpr = calCol.expression;
            calColVars.forEach(v => {
               const d = data.find(d => d.key === v);
               if (d) {
                  resolvedExpr = resolvedExpr.replace('{{' + v + '}}', d.value);
               }
            });

            const item = { key: calCol.name, value: eval(resolvedExpr), isVisible: true };
            const positionParts = calCol.position.split('::');
            if (positionParts[0] === 's') {
               data.splice(this.originalData.length + sSeq++, 0, item);
            } else {
               const ind = data.findIndex(d => d.key.toString().toLowerCase() === positionParts[1].toString().toLowerCase());
               if (ind === -1)
                  data.push(item);
               else if (ind === 0)
                  data.splice(1, 0, item);
               else {
                  if (positionParts[0] === 'b')
                     data.splice(ind, 0, item);
                  else
                     data.splice(ind + 1, 0, item);
               }
            }
         });

         this.kpiData = [...data.filter(d => d.isVisible)];
         this.$emit('ready', true);
      }
   },

   created() { },
   mounted() { }
}
</script>

<style scoped>
</style>